import NotFoundPage from '@/pages/NotFoundPage';
import ScrollToTop from '@/shared/components/ScrollToTop';
import { LanguageProvider } from '@/shared/contexts/LanguageContext';
import Footer from '@/shared/ui/footer';
import { Suspense, lazy } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

// 导入学术页面组件
import CVPage from '@/pages/academic/CVPage';
import HomePage from '@/pages/academic/HomePage';
import PostDetailPage from '@/pages/academic/PostDetailPage';
import PostsPage from '@/pages/academic/PostsPage';
import ProjectPage from '@/pages/academic/ProjectPage';

// 导入个人页面组件
import { default as PersonalAboutPage } from '@/pages/personal/AboutPage';
import BlogDetailPage from '@/pages/personal/BlogDetailPage';
import BlogPage from '@/pages/personal/BlogPage';
import PortfolioPage from '@/pages/personal/PortfolioPage';
import SpacePage from '@/pages/personal/SpacePage';
import SpaceLayout from '@/shared/components/SpaceLayout';

// Admin页面按需加载：它引用了全部 ReactBits 组件（three.js/gsap 等），
// 懒加载可以避免这些依赖进入主 bundle
const AdminPage = lazy(() => import('@/pages/admin/AdminPage'));

function App() {
  const location = useLocation();

  // 判断是否在Admin页面
  const isAdminPage = location.pathname === '/admin';

  return (
    <LanguageProvider>
      <ScrollToTop />
      <div className="relative flex min-h-screen flex-col">
        <div className="flex-1">
          <Routes>
            {/* 学术网站路由 */}
            <Route path="/" element={<HomePage />} />
            <Route path="/project" element={<ProjectPage />} />
            <Route path="/posts" element={<PostsPage />} />
            <Route path="/posts/:slug" element={<PostDetailPage />} />
            <Route path="/cv" element={<CVPage />} />

            {/* 个人空间路由（SpaceLayout 提供 personal-theme + 浮动导航） */}
            <Route path="/space" element={<SpaceLayout />}>
              <Route index element={<SpacePage />} />
              <Route path="blog" element={<BlogPage />} />
              <Route path="blog/:slug" element={<BlogDetailPage />} />
              <Route path="portfolio" element={<PortfolioPage />} />
              <Route path="about" element={<PersonalAboutPage />} />
            </Route>

            {/* Admin管理页面 - 不显示在导航中 */}
            <Route
              path="/admin"
              element={
                <Suspense fallback={null}>
                  <AdminPage />
                </Suspense>
              }
            />

            {/* 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </div>
        {/* Footer组件 - 在Admin页面不显示 */}
        {!isAdminPage && <Footer />}
      </div>
    </LanguageProvider>
  );
}

export default App;
